import user from './user/user'
import activeTabIndex from './activeTabIndex/activeTabIndex'

export const userContext = user
export const activeTabIndexContext = activeTabIndex

